
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zmqgsgvldcfflkglylaa.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InptcWdzZ3ZsZGNmZmxrZ2x5bGFhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc1ODM3NTEsImV4cCI6MjA2MzE1OTc1MX0.8NM_RZny9pbBwUX2q0KQ4nUoiL_09BpmyELsHUrC88w";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true
    }
  }
);
